import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import ScrollReveal from "../../utils/ScrollReveal";
import Seo from "../../seo/Seo";

// import sections
import PageNotFoundImg from "../../components/sections/page-not-found/PageNotFoundImg";

const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

const PageNotFound = () => {
  const childRef = useRef();
  let location = useLocation();
  const page = location.pathname;

  useEffect(() => {
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
  }, [location, page]);

  return (
    <>
      <Seo title="Page Not Found" description="The page you were looking for could not be found." />
    <ScrollReveal
      ref={childRef}
      children={() => (
        <React.Fragment>
          {/* {page} */}
          <div className="bg-top" />
          <PageNotFoundImg id="PageNotFound" />
          <div className="bg-bottom" />
        </React.Fragment>
      )}
    />
    </>
  );
};

export default PageNotFound;
